export interface Comic {
  id: number;
  title: string;
  tagline: string;
  cover: string;
  genre: string;
  status: '连载中' | '已完结' | '即将上线';
  rating: number;
  chapter: string;
  progress: number;
  updateTime: string;
  views: string;
  hot: boolean;
  color: string;
}

export interface WeeklyDay {
  day: string;
  items: { title: string; chapter: string; genre: string }[];
}

export interface Category {
  name: string;
  desc: string;
  icon: string;
  count: number;
  color: string;
}

export interface Review {
  name: string;
  role: string;
  text: string;
  rating: number;
  color: string;
}

export interface Faq {
  q: string;
  a: string;
}

export const comics: Comic[] = [
  {
    id: 1, title: '剑与咒之森', tagline: '被放逐的剑士踏入禁忌咒术森林，只为寻回失落的家族之剑。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20manhwa%20cover%20illustration%20of%20a%20lone%20swordsman%20facing%20an%20ancient%20enchanted%20forest%2C%20mystical%20glowing%20green%20spirits%20among%20giant%20trees%2C%20dark%20green%20and%20gold%20palette%2C%20dramatic%20lighting%2C%20detailed%20webtoon%20art%2C%20vertical%20portrait%20composition%2C%20cinematic%20atmosphere&width=600&height=800&seq=comic-01&orientation=portrait',
    genre: '奇幻玄幻', status: '连载中', rating: 9.2, chapter: '第 128 话', progress: 64, updateTime: '今天 09:20', views: '86.4万', hot: true, color: 'bg-primary-500',
  },
  {
    id: 2, title: '心动信号第99天', tagline: '大学广播台里，两个互相暗恋的人隔着电波互相告白。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20romance%20webtoon%20cover%20illustration%20of%20a%20young%20couple%20inside%20a%20cozy%20university%20radio%20booth%2C%20soft%20pastel%20pink%20and%20peach%20tones%2C%20warm%20cafe%20lighting%2C%20gentle%20expressions%2C%20sweet%20romantic%20mood%2C%20clean%20modern%20webtoon%20style%2C%20vertical%20portrait%20composition&width=600&height=800&seq=comic-02&orientation=portrait',
    genre: '恋爱浪漫', status: '连载中', rating: 9.0, chapter: '第 86 话', progress: 47, updateTime: '今天 10:05', views: '72.1万', hot: true, color: 'bg-accent-500',
  },
  {
    id: 3, title: '重生之都市药神', tagline: '中医世家的少年重回十年前，用一双手改写命运轨迹。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20urban%20fantasy%20webtoon%20cover%20illustration%20of%20a%20confident%20young%20man%20in%20modern%20city%20with%20glowing%20herbal%20energy%20around%20his%20hands%2C%20warm%20amber%20and%20teal%20contrast%2C%20city%20skyline%20background%2C%20dynamic%20energy%20effects%2C%20vibrant%20manhwa%20art%2C%20vertical%20portrait%20composition&width=600&height=800&seq=comic-03&orientation=portrait',
    genre: '都市现实', status: '已完结', rating: 8.8, chapter: '全 245 话', progress: 100, updateTime: '昨天 22:40', views: '113.8万', hot: false, color: 'bg-secondary-500',
  },
  {
    id: 4, title: '星轨侦探社', tagline: '一家只接怪案的侦探社，每一个案子背后都藏着星空的秘密。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20mystery%20webtoon%20cover%20illustration%20of%20a%20noir%20detective%20agency%20with%20constellation%20patterns%20woven%20into%20night%20sky%2C%20deep%20navy%20teal%20and%20gold%2C%20silhouette%20detective%20with%20trench%20coat%2C%20mysterious%20moody%20lighting%2C%20intricate%20manhwa%20art%2C%20vertical%20portrait%20composition&width=600&height=800&seq=comic-04&orientation=portrait',
    genre: '悬疑惊悚', status: '连载中', rating: 9.4, chapter: '第 54 话', progress: 31, updateTime: '今天 11:12', views: '58.9万', hot: true, color: 'bg-accent-700',
  },
  {
    id: 5, title: '电竞之王的逆袭', tagline: '被逐出豪门战队的天才选手，组起草根队伍杀回职业联赛。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20esports%20sports%20webtoon%20cover%20illustration%20of%20a%20focused%20young%20gamer%20with%20headset%20in%20front%20of%20glowing%20screens%2C%20electric%20orange%20and%20cyan%20neon%20lighting%2C%20intense%20competitive%20atmosphere%2C%20dynamic%20composition%2C%20bold%20vibrant%20manhwa%20art%2C%20vertical%20portrait%20composition&width=600&height=800&seq=comic-05&orientation=portrait',
    genre: '热血动作', status: '连载中', rating: 8.9, chapter: '第 112 话', progress: 58, updateTime: '今天 08:45', views: '94.2万', hot: true, color: 'bg-primary-600',
  },
  {
    id: 6, title: '月光下的狼族', tagline: '平凡少女意外卷入狼族继承之争，月光之约让她无法回头。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20romance%20webtoon%20cover%20illustration%20of%20a%20girl%20with%20silver%20wolf%20by%20her%20side%20under%20full%20moonlight%2C%20cool%20silver%20blue%20and%20lavender%20tones%2C%20luminous%20moon%2C%20ethereal%20magical%20atmosphere%2C%20elegant%20detailed%20manhwa%20art%2C%20vertical%20portrait%20composition&width=600&height=800&seq=comic-06&orientation=portrait',
    genre: '恋爱浪漫', status: '连载中', rating: 9.1, chapter: '第 72 话', progress: 39, updateTime: '今天 13:30', views: '66.7万', hot: true, color: 'bg-secondary-600',
  },
  {
    id: 7, title: '厨房里的魔女', tagline: '会施法的魔女在街角开了一家小店，用料理治愈每个迷路的人。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20cooking%20fantasy%20webtoon%20cover%20illustration%20of%20a%20warm%20kitchen%20with%20a%20young%20witch%20cooking%20steaming%20magical%20dishes%2C%20cozy%20golden%20amber%20and%20warm%20cream%20tones%2C%20floating%20spices%20and%20sparkles%2C%20wholesome%20charming%20manhwa%20art%2C%20vertical%20portrait%20composition&width=600&height=800&seq=comic-07&orientation=portrait',
    genre: '日常治愈', status: '已完结', rating: 8.7, chapter: '全 98 话', progress: 100, updateTime: '前天 18:20', views: '45.3万', hot: false, color: 'bg-accent-500',
  },
  {
    id: 8, title: '失控的机械心脏', tagline: '换上机械心脏的少年，开始听见这座城市被隐藏的声音。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20sci-fi%20thriller%20webtoon%20cover%20illustration%20of%20a%20boy%20with%20glowing%20mechanical%20heart%20in%20his%20chest%2C%20neon%20cyberpunk%20city%20reflection%2C%20cool%20teal%20and%20deep%20gray%20palette%2C%20intricate%20machine%20detail%2C%20suspenseful%20dark%20atmosphere%2C%20sleek%20manhwa%20art%2C%20vertical%20portrait%20composition&width=600&height=800&seq=comic-08&orientation=portrait',
    genre: '科幻末世', status: '连载中', rating: 9.3, chapter: '第 41 话', progress: 24, updateTime: '今天 07:55', views: '39.6万', hot: false, color: 'bg-primary-500',
  },
  {
    id: 9, title: '高校热血篮球部', tagline: '濒临解散的篮球部，在一群问题少年手里迎来重生。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20school%20sports%20webtoon%20cover%20illustration%20of%20high%20school%20basketball%20players%20in%20jump%20action%20on%20indoor%20court%2C%20warm%20orange%20and%20cream%20tones%2C%20sunlight%20through%20windows%2C%20energetic%20dynamic%20motion%2C%20youthful%20passion%2C%20vibrant%20manhwa%20art%2C%20vertical%20portrait%20composition&width=600&height=800&seq=comic-09&orientation=portrait',
    genre: '校园青春', status: '连载中', rating: 8.6, chapter: '第 156 话', progress: 72, updateTime: '今天 12:18', views: '78.5万', hot: false, color: 'bg-accent-600',
  },
  {
    id: 10, title: '替身皇后的秘密', tagline: '被迫顶替姐姐嫁入皇宫的少女，却在深宫中改写了自己的命运。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20historical%20fantasy%20webtoon%20cover%20illustration%20of%20an%20elegant%20queen%20in%20hanbok-inspired%20robes%20in%20a%20grand%20traditional%20palace%2C%20rich%20crimson%20and%20gold%20tones%2C%20ornate%20details%2C%20regal%20moody%20lighting%2C%20beautiful%20detailed%20manhwa%20art%2C%20vertical%20portrait%20composition&width=600&height=800&seq=comic-10&orientation=portrait',
    genre: '古风权谋', status: '连载中', rating: 9.0, chapter: '第 63 话', progress: 35, updateTime: '今天 14:02', views: '61.4万', hot: false, color: 'bg-secondary-500',
  },
  {
    id: 11, title: '深渊之瞳', tagline: '每当午夜降临，主角就能看到普通人看不见的东西。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20horror%20webtoon%20cover%20illustration%20of%20a%20giant%20mysterious%20eye%20in%20the%20dark%20abyss%20staring%20at%20a%20silhouette%20figure%2C%20deep%20black%20and%20blood%20red%20accents%2C%20cerie%20ominous%20atmosphere%2C%20high%20contrast%20terrifying%20mood%2C%20stylized%20manhwa%20art%2C%20vertical%20portrait%20composition&width=600&height=800&seq=comic-11&orientation=portrait',
    genre: '悬疑惊悚', status: '连载中', rating: 8.5, chapter: '第 37 话', progress: 20, updateTime: '昨天 21:33', views: '28.7万', hot: false, color: 'bg-primary-700',
  },
  {
    id: 12, title: '云端咖啡馆', tagline: '开在楼顶的咖啡馆，记录着城市里每一个温暖的故事。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20slice%20of%20life%20webtoon%20cover%20illustration%20of%20a%20cozy%20rooftop%20cafe%20among%20clouds%20with%20warm%20afternoon%20sunlight%2C%20soft%20pastel%20cream%20and%20dusty%20rose%20tones%2C%20plants%20and%20cups%20of%20coffee%2C%20calm%20peaceful%20everyday%20mood%2C%20gentle%20charming%20manhwa%20art%2C%20vertical%20portrait%20composition&width=600&height=800&seq=comic-12&orientation=portrait',
    genre: '日常治愈', status: '已完结', rating: 8.9, chapter: '全 80 话', progress: 100, updateTime: '周一 16:40', views: '52.2万', hot: false, color: 'bg-accent-500',
  },
];

export const categories: Category[] = [
  { name: '奇幻玄幻', desc: '魔法、异世界与神魔之争，想象力无边界', icon: 'ri-sparkling-2-line', count: 368, color: 'bg-primary-500' },
  { name: '都市现实', desc: '贴近生活的现实题材，映照都市众生相', icon: 'ri-building-line', count: 291, color: 'bg-accent-500' },
  { name: '恋爱浪漫', desc: '甜虐交织的恋爱故事，心动一触即发', icon: 'ri-heart-3-line', count: 342, color: 'bg-secondary-500' },
  { name: '热血动作', desc: '战斗与成长，热血少年永远年轻', icon: 'ri-flashlight-line', count: 256, color: 'bg-primary-600' },
  { name: '悬疑惊悚', desc: '烧脑反转与心跳加速，猜不到结局', icon: 'ri-focus-3-line', count: 189, color: 'bg-accent-700' },
  { name: '科幻末世', desc: '机械、末世与未来想象，人类的最终边界', icon: 'ri-rocket-2-line', count: 173, color: 'bg-primary-700' },
  { name: '校园青春', desc: '课桌间的热血与心动，青春正当下', icon: 'ri-school-line', count: 224, color: 'bg-accent-500' },
  { name: '古风权谋', desc: '宫廷江湖，权谋与情义的交锋', icon: 'ri-sword-line', count: 158, color: 'bg-secondary-600' },
  { name: '日常治愈', desc: '细碎生活里的温暖与光，治愈每一个瞬间', icon: 'ri-cup-line', count: 137, color: 'bg-accent-600' },
  { name: '体育竞技', desc: '赛场上的拼搏与坚持，热血永不止步', icon: 'ri-trophy-line', count: 96, color: 'bg-primary-500' },
];

export const weeklyUpdate: WeeklyDay[] = [
  {
    day: '周一', items: [
      { title: '云端咖啡馆', chapter: '第 81 话', genre: '日常治愈' },
      { title: '深渊之瞳', chapter: '第 38 话', genre: '悬疑惊悚' },
      { title: '重生之都市药神', chapter: '番外 3', genre: '都市现实' },
    ],
  },
  {
    day: '周二', items: [
      { title: '电竞之王的逆袭', chapter: '第 113 话', genre: '热血动作' },
      { title: '心动信号第99天', chapter: '第 87 话', genre: '恋爱浪漫' },
    ],
  },
  {
    day: '周三', items: [
      { title: '剑与咒之森', chapter: '第 129 话', genre: '奇幻玄幻' },
      { title: '高校热血篮球部', chapter: '第 157 话', genre: '校园青春' },
    ],
  },
  {
    day: '周四', items: [
      { title: '星轨侦探社', chapter: '第 55 话', genre: '悬疑惊悚' },
      { title: '月光下的狼族', chapter: '第 73 话', genre: '恋爱浪漫' },
    ],
  },
  {
    day: '周五', items: [
      { title: '替身皇后的秘密', chapter: '第 64 话', genre: '古风权谋' },
      { title: '失控的机械心脏', chapter: '第 42 话', genre: '科幻末世' },
    ],
  },
  {
    day: '周六', items: [
      { title: '厨房里的魔女', chapter: '番外 1', genre: '日常治愈' },
      { title: '电竞之王的逆袭', chapter: '第 114 话', genre: '热血动作' },
    ],
  },
  {
    day: '周日', items: [
      { title: '剑与咒之森', chapter: '第 130 话', genre: '奇幻玄幻' },
      { title: '星轨侦探社', chapter: '第 56 话', genre: '悬疑惊悚' },
      { title: '心动信号第99天', chapter: '第 88 话', genre: '恋爱浪漫' },
    ],
  },
];

export const reviews: Review[] = [
  { name: '林小满', role: '追漫 3 年', text: '韩国漫画大全的更新速度是真的快，连载进度跟得特别勤，最新韩漫上线当天就能看到，追番体验非常顺畅。', rating: 5, color: 'bg-primary-500' },
  { name: '阿哲', role: '漫画编辑', text: '内容收录得很全，分类也清晰，每周更新一目了然。我每天上班第一件事就是上来刷一遍今日更新。', rating: 5, color: 'bg-accent-500' },
  { name: '苏苏', role: '悬疑爱好者', text: '连载进度同步这点太实用了，不会追着追着就断更。站内的推荐质量也很高，挖到好几部宝藏韩漫。', rating: 4, color: 'bg-secondary-500' },
  { name: '大鹏', role: '下班党', text: '界面清爽不花哨，找漫画特别快。每天更新不停歇，已经养成睡前刷一会儿的习惯了。', rating: 5, color: 'bg-accent-600' },
];

export const faqs: Faq[] = [
  { q: '韩国漫画大全多久更新一次？', a: '我们坚持每日更新不停歇。连载中的作品会在作者更新的第一时间收录同步，本周更新板块每天刷新，让你随时掌握最新的连载进度。' },
  { q: '「本周更新」是怎么汇总的？', a: '本站按周一到周日整理各作品的最新话数与更新时间，形成一目了然的周更新列表，方便你快速确认本周追的漫画有没有更新。' },
  { q: '为什么有的漫画标注「已完结」？', a: '已完结的作品表示原作连载已经收官，我们收录了全部话数并整理成完本，方便你一口气从头看到尾。' },
  { q: '「即将上线」的漫画什么时候可以看？', a: '即将上线的作品会在确定上线时间后第一时间收录并标注预告，正式上线当天会同步更新到最新上线与本周更新板块。' },
  { q: '如何快速找到想看的漫画？', a: '你可以通过顶部搜索框直接搜索漫画名，也可以按奇幻玄幻、恋爱浪漫等分类浏览，或进入连载进度页按状态筛选，三种方式都能快速定位。' },
  { q: '最新上线的韩漫新作会提前预告吗？', a: '会的。重要新作上线前我们会提前放出预告与简介，正式上线后立即收录进最新上线板块，确保第一时间可见。' },
];